import React from 'react';
import { History } from 'history';
import { Input, InputEmail, InputFile, InputMultiline, InputSelect, InputSwitch, InputPicklist } from '../../components';
import BaseView from '../base/base-view.component'; 
import Model from './message-model';  //editable..
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    caption?: string;
    astemplate?: string;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class MessageView extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }
    
    render() {
        return (
            //editable..
            <BaseView history={this.props.history} caption={this.props.caption} 
                model={Model} onLoad={this.onLoad}>              
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} readOnly/>
                }
                <InputSelect name='type' label='Type' value={this.state.datarow.type} options={Model.optionType} readOnly/>
                {this.props.astemplate!=='yes' &&
                <InputSwitch name='sent' label='Sent' value={this.state.datarow.sent} readOnly/>
                }
                {this.state.datarow.type==='email'?
                <>
                <InputEmail name='to' label='To' value={this.state.datarow.to} readOnly/>
                <InputEmail name='cc' label='Cc' value={this.state.datarow.cc} readOnly/>
                <InputEmail name='bcc' label='Bcc' value={this.state.datarow.bcc} readOnly/>
                <InputEmail name='replyto' label='Reply to' value={this.state.datarow.replyto} readOnly/>
                </>
                : 
                <Input name='to' label='To' value={this.state.datarow.to} readOnly/>
                }
                <Input name='subject' label='Subject' value={this.state.datarow.subject} readOnly/>
                <InputMultiline name='text' label='Text' value={this.state.datarow.text} readOnly/>
                <InputFile name='attachmentUrl' label='Attachment' value={this.state.datarow.attachmentUrl} readOnly/>
           
            </BaseView>
        );
    }
}